import type { Route } from '#/global'
import type { RouteRecordRaw } from 'vue-router'
import generatedRoutes from 'virtual:generated-pages'
import { setupLayouts } from 'virtual:meta-layouts'
import AdminManagement from './modules/admin.management'
import AiConfigManagement from './modules/ai-config.management'
import AiManagement from './modules/ai.management'
import AnnouncementManagement from './modules/announcement.management'
import AppVersionManagement from './modules/app-version.management'
import FeedbackCategoryManagement from './modules/feedback-category.management'
import FeedbackManagement from './modules/feedback.management'
import HelpCategoryManagement from './modules/help-category.management'
import HelpCenterManagement from './modules/help-center.management'
import ModuleManagement from './modules/module.management'
import MultilevelMenuExample from './modules/multilevel.menu.example'
import OrderManagement from './modules/order.management'
import ProductManagement from './modules/product.management'
import StudentManagement from './modules/student.management'
import SystemManagement from './modules/system.management'
import TeamManagement from './modules/team.management'

// 暂时未使用的模块，避免 TypeScript 警告
void MultilevelMenuExample

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: () => useSettingsStore().settings.home.title,
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: () => useSettingsStore().settings.home.title,
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: '重新加载',
          breadcrumb: false,
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/profile/index.vue'),
        meta: {
          title: '个人设置',
          menu: false,
        },
      },
      {
        path: 'profile/password',
        name: 'profile-password',
        component: () => import('@/views/profile/password.vue'),
        meta: {
          title: '修改密码',
          menu: false,
        },
      },
    ],
  },
]

// 动态路由（异步路由、导航栏路由）
const asyncRoutes: Route.recordMainRaw[] = [
  {
    meta: {
      title: '用户管理',
      icon: 'i-ep:user',
    },
    children: [
      StudentManagement,
    ],
  },
  {
    meta: {
      title: '订单管理',
      icon: 'i-ep:shopping-cart',
    },
    children: [
      OrderManagement,
    ],
  },
  {
    meta: {
      title: '模块管理',
      icon: 'i-ep:Connection',
    },
    children: [
      ModuleManagement,
    ],
  },
  {
    meta: {
      title: '套餐卡管理',
      icon: 'i-ep:Postcard',
    },
    children: [
      ProductManagement,
    ],
  },
  {
    meta: {
      title: '团队管理',
      icon: 'i-ep:office-building',
    },
    children: [
      TeamManagement,
    ],
  },
  {
    meta: {
      title: 'APP版本',
      icon: 'i-ep:Promotion',
    },
    children: [
      AppVersionManagement,
    ],
  },
  {
    meta: {
      title: '帮助中心',
      icon: 'i-ep:document',
    },
    children: [
      HelpCategoryManagement,
      HelpCenterManagement,
    ],
  },
  {
    meta: {
      title: '意见反馈',
      icon: 'i-ep:chat-dot-round',
    },
    children: [
      FeedbackCategoryManagement,
      FeedbackManagement,
    ],
  },
  {
    meta: {
      title: 'AI管理',
      icon: 'i-ep:cpu',
    },
    children: [
      AiManagement,
      AiConfigManagement,
    ],
  },
  {
    meta: {
      title: '设置',
      icon: 'i-ep:setting',
    },
    children: [
      AdminManagement,
      SystemManagement,
      AnnouncementManagement,
    ],
  },
]

const constantRoutesByFilesystem = generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant === true
})

const asyncRoutesByFilesystem = setupLayouts(generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant !== true && item.meta?.layout !== false
}))

export {
  asyncRoutes,
  asyncRoutesByFilesystem,
  constantRoutes,
  constantRoutesByFilesystem,
  systemRoutes,
}
